import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("ID"),
            field: "id",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("themeArea"),
            field: "area",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("hasRelatedSkills"),
            field: "hasSkills",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("published"),
            field: "publishedString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("recognitionPoints"),
            field: "points",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("themes"),
            field: "themes",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("length"),
            field: "length",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("certification"),
            field: "certification",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.coursesMaster],
        config: {
            headerName: getLocalizedString("usedSpaceMB"),
            field: "usedSpaceMB",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/modules"],
        config: {
            headerName: getLocalizedString("order"),
            field: "order",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: ["/coursesMaster/modules"],
        config: {
            headerName: getLocalizedString("module"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("module"),
            field: "moduleString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("order"),
            field: "order",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("type"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("hasResources"),
            field: "hasResourcesString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("length"),
            field: "length",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("courseMode"),
            field: "sessions",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/activities"],
        config: {
            headerName: getLocalizedString("dependency"),
            field: "dependency",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/questions"],
        config: {
            headerName: getLocalizedString("question"),
            field: "text",
            filter: "agTextColumnFilter",
            cellRenderer: "RichTextRenderer",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: ["/coursesMaster/questions"],
        config: {
            headerName: getLocalizedString("answer"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/coursesMaster/questions"],
        config: {
            headerName: getLocalizedString("options"),
            field: "optionsAmount",
            filter: "agTextColumnFilter",
        }
    },
]